// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-progress-dots{align-items:center;display:flex;min-height:30px}.ac-progress-dots__back,.ac-progress-dots__next{z-index:1}.ac-progress-dots__next{margin-left:auto}.ac-progress-dots__list{display:flex;justify-content:center;left:0;position:absolute;width:100%}.ac-progress-dots__item{border-radius:50%;background:#a9a9a9;height:0.75rem;width:0.75rem}.ac-progress-dots__item:not(:first-child){margin-left:1rem}.ac-progress-dots__item--active{background:#5d5d5d}\n", ""]);
// Exports
module.exports = exports;
